import useCanManageApiKeys from "shared/ApiKey/access/useCanManageApiKeys";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import useTypedContext from "hooks/useTypedContext";
import { showManageRolesDrawer } from "views/Account/Settings/ApiKey/ManageRolesDrawer";

import { showApiKeysEditDrawer } from "../../../ApiKey/EditDrawer";
import { showApiKeysManageGroupsDrawer } from "../../../ApiKey/ManageGroupsDrawer";
import { CellComponentProps } from "../types";
import { SettingsContext } from "../../../Context";

type ApiKeysListItemDropdownActionsCellProps = CellComponentProps;

const ApiKeysListItemDropdownActionsCell = ({
  apiKey,
  refetchQueriesOnDelete,
  refetchQueriesOnUpdate,
}: ApiKeysListItemDropdownActionsCellProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);
  const canManageApiKeys = useCanManageApiKeys();

  const onDeleteClick = () => {
    showDeleteConfirmation({
      name: apiKey.name,
      id: apiKey.id,
      refetchQueriesOnDelete,
    });
  };

  const onManageRolesClick = () => {
    showManageRolesDrawer({
      apiKeyId: apiKey.id,
      activationStatus,
    });
  };

  const onEditDetailsClick = () => {
    showApiKeysEditDrawer({
      apiKey,
      refetchQueriesOnUpdate,
    });
  };

  const onManageGroupsClick = () => {
    showApiKeysManageGroupsDrawer({
      apiKey,
      activationStatus,
      refetchQueriesOnUpdate,
    });
  };

  return (
    <DropdownMenuEllipsis tooltip="API key actions">
      {canManageApiKeys && (
        <DropdownMenuItem onAction={onEditDetailsClick}>Edit details</DropdownMenuItem>
      )}
      <DropdownMenuItem onAction={onManageRolesClick}>Manage roles</DropdownMenuItem>
      {canManageApiKeys && (
        <DropdownMenuItem onAction={onManageGroupsClick}>Manage groups</DropdownMenuItem>
      )}
      {canManageApiKeys && (
        <DropdownMenuItem onAction={onDeleteClick} danger>
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default ApiKeysListItemDropdownActionsCell;
